var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2273 4.28571C11.3591 4.28571 12.2659 3.32857 12.2659 2.14286C12.2659 0.957143 11.3591 0 10.2273 0C9.09545 0 8.18182 0.957143 8.18182 2.14286C8.18182 3.32857 9.09545 4.28571 10.2273 4.28571ZM4.77273 4.28571C5.90455 4.28571 6.81136 3.32857 6.81136 2.14286C6.81136 0.957143 5.90455 0 4.77273 0C3.64091 0 2.72727 0.957143 2.72727 2.14286C2.72727 3.32857 3.64091 4.28571 4.77273 4.28571ZM4.77273 5.71429C3.18409 5.71429 0 6.55 0 8.21429V10H9.54545V8.21429C9.54545 6.55 6.36136 5.71429 4.77273 5.71429ZM10.2273 5.71429C10.0295 5.71429 9.80455 5.72857 9.56591 5.75C10.3568 6.35 10.9091 7.15714 10.9091 8.21429V10H15V8.21429C15 6.55 11.8159 5.71429 10.2273 5.71429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/GroupIcon.723a60993fe4c75cd440fc37e4dc117f.svg";
export { ForwardRef as ReactComponent };